<div class="dot_container">
  <div 
    class="dot dot--top" 
    [ngClass]="{
      'dot--green': greenPosition === 1,
      'dot--blue': bluePosition === 1,
      'dot--orange': orangePosition === 1,
    }">
  </div>
  <div 
    class="dot dot--right" 
    [ngClass]="{
      'dot--green': greenPosition === 3,
      'dot--blue': bluePosition === 3,
      'dot--orange': orangePosition === 3,
    }">
  </div>
  <div 
    class="dot dot--bottom" 
    [ngClass]="{
      'dot--green': greenPosition === 5,
      'dot--blue': bluePosition === 5,
      'dot--orange': orangePosition === 5,
    }">
  </div>  
  <div 
    class="dot dot--left" 
    [ngClass]="{
      'dot--green': greenPosition === 7,
      'dot--blue': bluePosition === 7,
      'dot--orange': orangePosition === 7,
    }">
  </div>
</div>